import type { SystemStyleObject } from "@chakra-ui/theme-tools";

export const scrollbarStyles: SystemStyleObject = {
    "::-webkit-scrollbar": { width: "2px", height: "2px" },
    "::-webkit-scrollbar-thumb": { background: "black" },
    "::-webkit-scrollbar-track": { background: "gray.200" },
    //hex value used here because chakra colors don't resolved here and broke this style
    scrollbarColor: "gray.200",
};
